import * as _ from 'underscore'

import { ConvertHelper, DataProvider, ToastHelper } from "../helpers"

import { Enums } from "../models/common/enums"
import { OpData, OpDevice, OpDeviceHierarchy } from "../models/core"
import { OpActionResult, OpSchema } from "../models/custom"
import { ColumnInfo } from "../models/custom/column-info"
import { DataProviderRequest } from "./utils"

export class DataProviderDevice {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End

    // Public Methods

    public deleteDevice = (opObj: OpDevice): JQueryPromise<OpDevice> => {
        opObj.opState = Enums.OpChangeState.Delete
        opObj.dataList.setValue(Enums.DeviceStateType.ERASED, Enums.DataType.HELPER_ID_DEVICE_STATE_TYPE)

        return this.saveDevice(opObj)
    }

    public getDevice = (id: number): DataProviderRequest<OpDevice> => {
        const promise: JQueryPromise<OpDevice> = this.dataProvider
            .sendRequestWithSession('OpxGetDevice', { SerialNbr: id }, 'OpxGetDeviceResult')
            .then((data: any) => {
                if (data) {
                    const result: OpDevice = new OpDevice(data)

                    OpDevice.loadNavigationProperties(this.dataProvider, [result])

                    return result
                }

                return null
            })
            .fail((error) => {
                const msg: string = ConvertHelper.getRequestErrorMessage(error)
                ToastHelper.showError(msg)
            })

        return DataProviderRequest.fromJQuery(promise)
    }

    public getDeviceFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpDevice>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.SerialNbr, 'OpxDeviceFilter', 'OpxDeviceFilterResult')
    }

    public getDeviceConfigurationInconsistency = (serialNbrs: number[]): JQueryPromise<OpData[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetDeviceConfigurationInconsistency', { SerialNbr: serialNbrs }, 'OpxGetDeviceConfigurationInconsistencyResult')
            .then((data: any[]) => {
                return data.map(opObj => new OpData(opObj))
            })
    }

    public sendDeviceConfiguration = (serialNumbers: number[]): JQueryPromise<OpActionResult[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSendDeviceConfiguration', { SerialNbr: serialNumbers }, 'OpxSendDeviceConfigurationResult')
            .then((data: any[]) => data.map(dataItem => new OpActionResult(dataItem)))
    }

    public saveDevice = (opObj: OpDevice): JQueryPromise<OpDevice> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveDevice', { ToBeSaved: opObj.toJSON() }, 'OpxSaveDeviceResult')
            .then((data: any) => {
                if (data) {
                    const result: OpDevice = new OpDevice(data)

                    OpDevice.loadNavigationProperties(this.dataProvider, [result])

                    return result
                }

                return null;
            })
    }

    public getParentDevices = (serialNbr: number): JQueryPromise<OpDeviceHierarchy[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetParentDevices', { SerialNbr: serialNbr }, 'OpxGetParentDevicesResult')
            .then(data => {
                if (_.isArray(data)) {
                    return data.map((deviceHierarchy: any) => {
                        const result: OpDeviceHierarchy = new OpDeviceHierarchy(deviceHierarchy)

                        OpDeviceHierarchy.loadNavigationProperties(this.dataProvider, [result])

                        return result
                    })
                }

                return null
            })
    }

    public getChildDevices = (serialNbr: number): JQueryPromise<OpDeviceHierarchy[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetChildDevices', { SerialNbr: serialNbr }, 'OpxGetChildDevicesResult')
            .then(data => {
                if (data) {
                    return data.map((deviceHierarchy: any) => {
                        const result: OpDeviceHierarchy = new OpDeviceHierarchy(deviceHierarchy)

                        OpDeviceHierarchy.loadNavigationProperties(this.dataProvider, [result])

                        return result
                    })
                }

                return null
            })
    }

    public saveChildDevices = (childDeviceHierarchy: OpDeviceHierarchy[]): JQueryPromise<void> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveChildDevices', { childDeviceHierarchy: childDeviceHierarchy }, null)
    }

    //#region Schema

    public getDeviceSchemas = (serialNbr: number): JQueryPromise<OpSchema[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetDeviceSchema', { SerialNbr: serialNbr }, 'OpxGetDeviceSchemaResult')
            .then((response: any[]) => DataProvider.convertArrayResult<OpSchema>(response, OpSchema))
    }

    //#endregion

    // Public Methods End
}
